export default "__VITE_ASSET__bb38541f__"